import { create } from 'zustand';

import {
  cropConnectApiClient,
  CropConnectTaskDto,
} from '../services/cropConnectApiClient';

interface MyTaskStore {
  tasks: CropConnectTaskDto[];
  isLoading: boolean;
  error: string | null;
  fetchTasks: () => Promise<void>;
}

export const useMyTaskStore = create<MyTaskStore>((set) => ({
  tasks: [],
  isLoading: false,
  error: null,

  fetchTasks: async () => {
    try {
      set({ isLoading: true, error: null });

      const response = await cropConnectApiClient.getTasks();

      if (response.success && response.data) {
        set({
          tasks: Array.isArray(response.data) ? response.data : [response.data],
          isLoading: false,
        });
      } else {
        set({
          tasks: [],
          isLoading: false,
          error: 'No tasks available',
        });
      }
    } catch (error) {
      console.error('Error fetching tasks:', error);
      set({
        error: error instanceof Error ? error.message : 'Unknown error',
        isLoading: false,
        tasks: [],
      });
    }
  },
}));
